import { render, staticRenderFns } from "./UserAddModal.vue?vue&type=template&id=061670a5&scoped=true&"
import script from "./UserAddModal.vue?vue&type=script&lang=js&"
export * from "./UserAddModal.vue?vue&type=script&lang=js&"
import style0 from "./UserAddModal.vue?vue&type=style&index=0&id=061670a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061670a5",
  null
  
)

export default component.exports